export default e=>e.charAt(0).toLowerCase()+e.slice(1).replace(/[A-Z\u00C0-\u00D6\u00D8-\u00DE]/g,e=>"_"+e.toLowerCase());
